const ErrorMessageUI = () => (
  <div className='flex flex-column gap-12'>
    <div className='flex align-items-center font-18 bold'>Oops, something went wrong !</div>
    <div className='flex align-items-center'>Please close this window and try again.</div>
    <div className='flex flex-column gap-4'>
      <div className='flex'>If you encounter this message again, please text an image of the issue and/or the order number it occurred on to the operations team at (480) 359-6826.</div>
      <div className='flex'>Be sure not to include any patient information in the image or text.</div>
    </div>
  </div>
);

export const ErrorMsg = {
  CONNECTION_ERROR: <ErrorMessageUI />,
};
